import { render, staticRenderFns } from "./MasterScreenCard.vue?vue&type=template&id=65dafb5f&scoped=true&"
import script from "./MasterScreenCard.vue?vue&type=script&lang=js&"
export * from "./MasterScreenCard.vue?vue&type=script&lang=js&"
import style0 from "./MasterScreenCard.vue?vue&type=style&index=0&id=65dafb5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dafb5f",
  null
  
)

export default component.exports